import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=7bfe2076&scoped=true"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"
import style0 from "./GameList.vue?vue&type=style&index=0&id=7bfe2076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfe2076",
  null
  
)

export default component.exports